var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 63,
    viewBox: "0 0 40 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.9375,
    y: 3.9375,
    width: 28.125,
    height: 56.25,
    rx: 2,
    fill: "white",
    stroke: "#236AC9",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 22.6875,
    width: 2.8125,
    height: 7.5,
    rx: 1,
    fill: "#D8FFEC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 22.6875,
    width: 2.8125,
    height: 7.5,
    rx: 1,
    fill: "#D8FFEC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 22.6875,
    width: 2.8125,
    height: 7.5,
    rx: 1,
    fill: "#D8FFEC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22.6875,
    width: 2.8125,
    height: 7.5,
    rx: 1,
    fill: "#D8FFEC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.75,
    y: 22.6875,
    width: 2.8125,
    height: 7.5,
    rx: 1,
    fill: "#D8FFEC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 22.6875,
    width: 2.8125,
    height: 7.5,
    rx: 1,
    fill: "#D8FFEC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.875,
    y: 4.875,
    width: 26.25,
    height: 46.875,
    rx: 1,
    fill: "#F2FAFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14.375,
    y: 3,
    width: 11.25,
    height: 3.75,
    rx: 1,
    fill: "#236AC9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 20.875,
    width: 28,
    height: 13,
    fill: "white",
    stroke: "#236AC9",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0685 26.0025L12.5165 26.8185L11.5325 27.1625L12.5165 27.4985L12.0365 28.3465L11.2365 27.6425L11.4365 28.6825H10.5005L10.6925 27.6425L9.9005 28.3545L9.4045 27.4905L10.3885 27.1465L9.4125 26.8265L9.8685 26.0025L10.7005 26.6985L10.4925 25.6425H11.4445L11.2365 26.6985L12.0685 26.0025ZM15.8419 26.0025L16.2899 26.8185L15.3059 27.1625L16.2899 27.4985L15.8099 28.3465L15.0099 27.6425L15.2099 28.6825H14.2739L14.4659 27.6425L13.6739 28.3545L13.1779 27.4905L14.1619 27.1465L13.1859 26.8265L13.6419 26.0025L14.4739 26.6985L14.2659 25.6425H15.2179L15.0099 26.6985L15.8419 26.0025ZM19.6154 26.0025L20.0634 26.8185L19.0794 27.1625L20.0634 27.4985L19.5834 28.3465L18.7834 27.6425L18.9834 28.6825H18.0474L18.2394 27.6425L17.4474 28.3545L16.9514 27.4905L17.9354 27.1465L16.9594 26.8265L17.4154 26.0025L18.2474 26.6985L18.0394 25.6425H18.9914L18.7834 26.6985L19.6154 26.0025ZM23.3888 26.0025L23.8368 26.8185L22.8528 27.1625L23.8368 27.4985L23.3568 28.3465L22.5568 27.6425L22.7568 28.6825H21.8208L22.0128 27.6425L21.2208 28.3545L20.7248 27.4905L21.7088 27.1465L20.7328 26.8265L21.1888 26.0025L22.0208 26.6985L21.8128 25.6425H22.7648L22.5568 26.6985L23.3888 26.0025ZM27.1623 26.0025L27.6103 26.8185L26.6263 27.1625L27.6103 27.4985L27.1303 28.3465L26.3303 27.6425L26.5303 28.6825H25.5943L25.7863 27.6425L24.9943 28.3545L24.4983 27.4905L25.4823 27.1465L24.5063 26.8265L24.9622 26.0025L25.7943 26.6985L25.5863 25.6425H26.5383L26.3303 26.6985L27.1623 26.0025ZM30.9357 26.0025L31.3837 26.8185L30.3997 27.1625L31.3837 27.4985L30.9037 28.3465L30.1037 27.6425L30.3037 28.6825H29.3677L29.5597 27.6425L28.7677 28.3545L28.2717 27.4905L29.2557 27.1465L28.2797 26.8265L28.7357 26.0025L29.5677 26.6985L29.3597 25.6425H30.3117L30.1037 26.6985L30.9357 26.0025Z",
    fill: "#2EA76D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerator);
export default __webpack_public_path__ + "static/media/generator.309e7914d310d1d63da289270dc5900d.svg";
export { ForwardRef as ReactComponent };